import { Gender, HeightUnit, WeightUnit } from 'core/constants';

import { CustomFieldResponse, PersonalDetailsResponse } from 'utils/api/modules/user/user.types';

export default class UserPersonalDetails {
  height = '';

  heightUnit: HeightUnit = HeightUnit.Meter;

  weight: number | null = null;

  weightUnit: WeightUnit = WeightUnit.Kilogram;

  distinguishingMarks = '';

  customInformation = '';

  birthDate: string | null = null;

  eyeColour = '';

  gender: Gender = Gender.Other;

  customFields: CustomFieldResponse[] = [];

  verificationWord = '';

  bloodType = '';

  medicalConditions = '';

  allergies = '';

  currentMedication = '';

  costCentre: string | null = null;

  constructor(data: PersonalDetailsResponse | null) {
    if (data) {
      Object.assign(this, data);
    }
  }

  get initialValues(): PersonalDetailsResponse {
    return {
      height: this.height,
      heightUnit: this.heightUnit,
      weight: this.weight,
      weightUnit: this.weightUnit,
      distinguishingMarks: this.distinguishingMarks,
      customInformation: this.customInformation,
      birthDate: this.birthDate || null,
      eyeColour: this.eyeColour,
      gender: this.gender,
      customFields: this.customFields,
      verificationWord: this.verificationWord,
      bloodType: this.bloodType,
      medicalConditions: this.medicalConditions,
      allergies: this.allergies,
      currentMedication: this.currentMedication,
      costCentre: this.costCentre,
    };
  }
}
